import axios from "axios";
import { ApiBaseUrl } from "../constants/endpoints";
// import { JWTTokenConfig } from "../constants/jwt";
import * as Common from "./common";
export const axiosInstance = axios.create({
  baseURL: ApiBaseUrl,
});

// axiosInstance.interceptors.request.use(
//     function (config) {
//         const token = getAuthToken();
//   var organizationID=Common.getUserCurrentOrganizatioId();
//         if (token != null) {
//             config.headers.Authorization = token;
//             config.headers.OrganizationID = organizationID;

//         }

//         return config;
//     },
//     function (err) {
//         return Promise.reject(err);
//     }
// );

// // Add a response interceptor
// axiosInstance.interceptors.response.use(
//     function (response) {
//         // Any status code that lie within the range of 2xx cause this function to trigger
//         // Do something with response data
//         return response;
//     },
//     function (error) {
//         try {
//             if (error.response.status === 401) logout();

//         } catch (ex) {
//             // Logout("apid");
//         }
//         // Any status codes that falls outside the range of 2xx cause this function to trigger
//         // Do something with response error
//         return Promise.reject(error);
//     }
// );
